import { render, staticRenderFns } from "./newPage.vue?vue&type=template&id=6df04b40&scoped=true"
import script from "./newPage.vue?vue&type=script&lang=js"
export * from "./newPage.vue?vue&type=script&lang=js"
import style0 from "./newPage.vue?vue&type=style&index=0&id=6df04b40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df04b40",
  null
  
)

export default component.exports